<template>
  <div class="wineclub exclusive">
    <section class="hero">
      <div class="copy">
        <h1>
          The Wine Access
          <span>Collector's Club</span>
        </h1>
        <p>
          Truly prestigious wines from the world’s blue-chip wine estates—direct
          from each coveted cellar to your door.
        </p>
        <div class="button-link text-center">
          <p>
            <a class="button primary" @click="signup()">
              <span class="button-inset">
                {{ ctaText }}
              </span>
            </a>
          </p>
          <p v-if="hasActiveGiftTerm">
            <span class="gift-alternative">
              <nuxt-link
                to="/wine-club/gifting/collectors-club/"
                class="button"
              >
                Or gift it
              </nuxt-link>
            </span>
          </p>
        </div>
      </div>
    </section>
    <section class="showpiece">
      <div class="row">
        <BreadcrumbComponent :breadcrumbs="breadcrumbs" />
        <header>
          <h2>Rare and Coveted Showpiece Selections</h2>
        </header>
        <p>
          The Collector’s Club is a diverse quarterly wine club focused on
          securing and sharing cellar-worthy treasures from the world’s most
          iconic wineries. Selections will span the world’s finest wine regions,
          including offerings from classed-growth Bordeaux estates, Grand Cru
          Burgundy Icons, cult Napa Valley producers, estate-aged library wines,
          exclusives never available at standard retail outlets, and more.
        </p>
      </div>
    </section>
    <section class="benefits">
      <div class="row">
        <header>
          <h2>Member benefits</h2>
        </header>
        <ul>
          <li>
            <span class="image">
              <img
                src="~assets/images/wineclub-box.svg"
                alt="Box Icon"
                role="presentation"
              />
            </span>
            <span class="copy">
              {{ deliveryFrequency }} {{ pricing }} Complimentary climate
              controlled storage and shipping on all Wine access orders.*
            </span>
          </li>
          <li>
            <span class="image">
              <img
                src="~assets/images/wineclub-glass.svg"
                alt="Wine Glass Icon"
                role="presentation"
              />
            </span>
            <span class="copy">
              Invitations to private tasting events with legendary estates,
              exclusive access to off-the-site selections, and first access to
              our most limited allocations.
            </span>
          </li>
          <li>
            <span class="image">
              <img
                src="~assets/images/wineclub-discount.svg"
                alt="Percent Symbol"
                role="presentation"
              />
            </span>
            <span class="copy">
              10% off all Wine Access purchases and access to wine concierge
              services *
            </span>
          </li>
        </ul>
        <div class="asterisked">
          <small
            >*Shipping not included on deliveries to Alaska and Hawaii.</small
          >
        </div>
      </div>
    </section>
    <CollectorsCurators />
    <section class="exclusive-footer">
      <div class="copy">
        <p>
          Our personal connections unlock the doors to the most coveted cellars,
          which in turn, means that members of the Collector’s Club gain access
          to a unique subset of coveted collectibles, to relish and enjoy for
          whatever occasion you deem special.
        </p>
        <div class="button-link">
          <p>
            <a class="button primary" @click="signup()">
              <span class="button-inset">
                {{ ctaText }}
              </span>
            </a>
          </p>
          <p v-if="hasActiveGiftTerm">
            <span class="gift-alternative">
              <nuxt-link
                to="/wine-club/gifting/collectors-club/"
                class="button"
              >
                Or gift it
              </nuxt-link>
            </span>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ga4 from '#common/utils/ga4'
import { getClubCrumbs } from '#common/utils/wineclub'

export default {
  name: 'CollectorsIndex',
  components: {
    BreadcrumbComponent: defineAsyncComponent(
      () => import('@/components/Breadcrumb.vue'),
    ),
    CollectorsCurators: defineAsyncComponent(
      () => import('@/components/Club/CollectorsCurators.vue'),
    ),
  },
  setup() {
    const { data, error } = useAsyncData('collectors-club', () =>
      $fetch('/api/membership/collectors-club', {
        query: { 'collectors-club-page': true },
      }),
    )

    if (error.value) {
      console.error(error.value)
      throw error.value
    }

    return {
      isFull: computed(
        () => data.value?.plans?.every((p) => p.is_full) || false,
      ),
      deliveryFrequency: computed(() => data.value?.delivery_freq_info || ''),
      pricing: computed(() => data.value?.pricing_info || ''),
      hasActiveGiftTerm: computed(
        () => data.value?.has_active_gift_term || false,
      ),
      breadcrumbs: getClubCrumbs('Collector’s Wine Club'),
    }
  },
  computed: {
    ctaText() {
      if (this.isFull) {
        return 'Join The Waiting List'
      } else {
        return 'Join the Club'
      }
    },
  },
  mounted() {
    ga4.trackViewClub({ slug: 'collectors' })
  },
  methods: {
    openLoginModal() {
      this.$auth.openAuthModal({
        redirect: '/collectors/join/',
        isClub: true,
      })
    },

    signup() {
      if (!this.$auth.loggedIn) {
        this.openLoginModal()
      } else {
        this.$router.push('/collectors/join/')
      }
    },
  },
}
</script>
